import React from 'react';
import ErrorScreen from './ErrorScreen';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep diagnostics available to developers without exposing technical
    // details or stack traces to end users.
    console.error('Application render error', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return <ErrorScreen />;
  }
}

export default AppErrorBoundary;
